import { AfterViewInit, Component, computed, inject, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppStore } from 'apps/multiblocks/src/app/store/types';
import { getQuickRenewErrors, QuickRenewActions } from 'apps/multiblocks/src/app/store/quick-renew';
import { AnalyticsActions } from '../../../store/analytics';
import { RequestErrorType } from '../../../store/generic-errors';
import { CommonModule } from '@angular/common';
import { MembershipUpdatePendingNoticeComponent } from '../../share/ava-membership-update-pending-notice.component';
import { ClubApp } from '@aaa/emember/types';
import { clubId } from '../../../signals';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  standalone: true,
  imports: [CommonModule, MembershipUpdatePendingNoticeComponent],
  selector: 'ava-join-confirmation',
  template: `
    <p class="tw-text-[22px] tw-font-extralight">Thank You</p>

    <p class="tw-text-base tw-font-extralight">
      Your Membership has been renewed. We appreciate your loyalty.
      @if (returnLink()) {
        <br />
        <a [attr.href]="returnLink()">Click here to return to your online account</a>
      }

      @if (executionError()?.type === RequestErrorType.MembershipError) {
        <ava-membership-update-pending-notice />
      }
    </p>
  `,
})
export class QuickRenewConfirmationComponent implements OnDestroy, AfterViewInit {
  readonly RequestErrorType = RequestErrorType;

  private store = inject(Store<AppStore>);
  returnLink = computed(() => {
    if (clubId() === ClubApp.Hoosier) {
      return 'https://hoosier.aaa.com/my-account';
    }

    if (clubId() === ClubApp.MidStates) {
      return 'https://midstates.aaa.com/my-account';
    }

    return '';
  });
  executionError = toSignal(this.store.select(getQuickRenewErrors), { initialValue: null });

  ngOnDestroy() {
    this.store.dispatch(QuickRenewActions.resetConfirmation());
  }

  ngAfterViewInit() {
    this.store.dispatch(AnalyticsActions.viewedPage({ eventName: `quick-renew-form-confirmation` }));
  }
}
